import styled, { css } from 'styled-components';
import ButtonIcon from 'components/ButtonIcon';

interface ItemProps {
    direction: 'outgoing' | 'incoming';
}

export const MediaContainer = styled.div<ItemProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    max-width: 70%;
    
    > div:first-child {
        max-width: 100%;
        width: fit-content;
    }

    ${(props) => props.direction === 'outgoing' && css`
        flex-direction: row-reverse;
    `};
`;

export const StyledButtonIcon = styled(ButtonIcon)<ItemProps>`
    position: absolute;
    top: 0;
    z-index: 1;

    & > svg {
        width: 1rem !important;
        height: 1rem !important;
    }

    ${(props) => props.direction === 'incoming' && css`
        right: -3rem;
    `};

    ${(props) => props.direction === 'outgoing' && css`
        left: -3rem;
    `};
`;
